module.exports = __webpack_public_path__ + "img/dashboard_account_mono_icon.628a6474.svg";